import { createContext } from 'react';

export const BasicModalContext = createContext(null);
